StepHandler = App.loadClass 'grower::handlers/placement/StepHandler'
PrescriptionMapKo = App.loadClass 'grower::viewmodels/placement/Prescription_Map'

class exports.PrescriptionMapHandler extends StepHandler

    inputSel: ''

    addValidationRules: ->
        @validator.registerRule
            selector: '.validate-int'
            text: '%s must be a whole number'
            func: (elem) =>
                val = $(elem).val()
                return not val or (not isNaN(val) and String(parseInt(val)) is val)


    getFieldAspect: (fieldID, aspectID) ->
        # Since we are using knockout, we will get the values of the inputs
        # from the knockout object as well.
        # TODO: Improve efficiency. This will call @stepKO.toJS() for every
        # field aspect, even though the object will be the same for all of them.
        # This definitely needs to be improved upon if we ever have separate
        # step templates and input types.

        koData = @stepKO.toJS()

        aspectName = @taffyObjects.y_aspects(aspects_id: aspectID).first().aspect_name
        retval =
            value: koData[@_autoAlias(aspectName)]

        # console.log retval
        return retval


    setFieldAspect: (fieldAspect) ->
        # don't do anything because the values are all set in the KO object
        return


    afterLoadLayout: (sel, data) ->
        # KNOCKOUT, STOP SCREWING WITH MY CRAP. SRSLY.
        # Call ko.cleanNode first so that knockout doesn't break validation
        # like a brain-damaged boxer with a bad temper. (Validation is set up
        # in StepHandler.afterLoadLayout().)
        ko.cleanNode @parent.dialog.find('#spp_body')[0]

        super(sel, data)

        # console.log @_getData()
        @stepKO = new PrescriptionMapKo(this, @_getData())
        ko.applyBindings @stepKO, @parent.dialog.find('#spp_body')[0]

        # add a custom click event handler to handle the toggle correctly
        rxMapsID = @taffyObjects.y_aspects(aspect_name: 'Create Rx Maps').first().aspects_id

        # This is backward. I'm not sure why, but it works perfectly checking
        # for NOT '.active', and refuses to work checking for '.active'. -SK
        @getInputEl(aspect: rxMapsID).on 'click', (el) =>
            @stepKO.create_rx_maps(not $(el).is('.active'))
        @getInputEl(aspect: -rxMapsID).on 'click', (el) =>
            @stepKO.create_rx_maps($(el).is('.active'))

        # add a custom click event handler to handle the toggle correctly
        rxPlansID = @taffyObjects.y_aspects(aspect_name: 'Multi-Hybrid Rx Plan').first().aspects_id

        @getInputEl(aspect: rxPlansID).on 'click', (el) =>
            @stepKO.multihybrid_rx_plan(not $(el).is('.active'))
        @getInputEl(aspect: -rxPlansID).on 'click', (el) =>
            @stepKO.multihybrid_rx_plan($(el).is('.active'))


    _getData: ->
        # arbitrarily use the first field ID
        field_id = @parent.taffyObjects.fields(selected: true).first().id

        planting_min_pop = @parent.getFieldAspectByName(field_id, 'Planting Min Pop')?.value ? null
        planting_max_pop = @parent.getFieldAspectByName(field_id, 'Planting Max Pop')?.value ? null

        data =
            'create_rx_maps': @parent.getFieldAspectByName(field_id, 'Create Rx Maps')?.value ? null
            default_min_pop: planting_min_pop ? @response?.data?.company_min_pop ? null
            default_max_pop: planting_max_pop ? @response?.data?.company_max_pop ? null
            'rx_map_min_pop': @parent.getFieldAspectByName(field_id, 'Rx Map Min Pop')?.value ? null
            'rx_map_max_pop': @parent.getFieldAspectByName(field_id, 'Rx Map Max Pop')?.value ? null
            'rx_map_max_num_pops': @parent.getFieldAspectByName(field_id, 'Rx Map Max Num Pops')?.value ? null
            'rx_map_min_pop_diff': @parent.getFieldAspectByName(field_id, 'Rx Map Min Pop Diff')?.value ? null
            'rx_map_max_pop_diff': @parent.getFieldAspectByName(field_id, 'Rx Map Max Pop Diff')?.value ? null
            company_min_pop_diff: @response?.data?.company_min_pop_diff ? null
            company_max_pop_diff: @response?.data?.company_max_pop_diff ? null
            'multihybrid_rx_plan': @parent.getFieldAspectByName(field_id, 'Multi-Hybrid Rx Plan')?.value ? null

        return data


    _autoAlias: (aspectName) ->
        return aspectName.toLowerCase().replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, '_')
